export default class CustomContactFieldsHelper {
  static prepareCustomContactFields(formModel) {
    const customContactFields = [];

    for (let index = 1; index <= 10; index++) {
      const label = formModel[`custom_contact_field_label_${index}`];
      let type = '';
      let options = '';
      if (label) {
        type = formModel['custom_contact_field_type_' + index];
        options =
          type === 'simple_choice' || type === 'multiple_choice'
            ? formModel['custom_contact_field_options_' + index]
            : '';
        const field = {
          id: index,
          label: label,
          type: type,
          options: options,
        };
        customContactFields.push(field);
      }
    }

    return customContactFields;
  }
}
